import React from 'react';

import Row from 'components/Common/Row';
import Tooltip from 'components/Tooltip';
import Badge from 'kingpin/atoms/Badge';
import Button from 'kingpin/atoms/Button';
import Typography from 'kingpin/atoms/Typography';

/**
 * Per-cell Clear for a week's persisted override in the sub-period fact table
 * (override mode). Shows a remove (×) button; once a Clear is staged it shows an
 * "Override Removed" badge whose × undoes the removal. The Clear goes through the
 * normal preview + Confirm flow.
 */
const WeeklyClearOverrideControl = ({
  isCleared,
  onClear,
  onUndo,
  testId,
}: {
  isCleared: boolean;
  onClear: () => void;
  onUndo: () => void;
  testId: string;
}) => {
  if (isCleared) {
    return (
      <Row centerAlign style={{ gap: 4 }}>
        <Badge badgeType={'Blue'} gap={4}>
          <Typography.Body type={'Badge'}>Override Removed</Typography.Body>
          <Tooltip content={'Undo'}>
            <Button
              testId={`${testId}-undo`}
              size={'X-Small - Circle'}
              type={'Ghost'}
              onClick={onUndo}
              icon={'cross'}
              iconColor={'var(--color-icon-secondary)'}
            />
          </Tooltip>
        </Badge>
      </Row>
    );
  }

  return (
    <Tooltip content={'Remove override'}>
      <Button
        testId={testId}
        size={'X-Small - Circle'}
        type={'Ghost'}
        onClick={onClear}
        icon={'cross'}
        iconColor={'var(--color-icon-secondary)'}
      />
    </Tooltip>
  );
};

export default WeeklyClearOverrideControl;
